import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-form-checkliste-lkt-biologo',
  templateUrl: './form-checkliste-lkt-biologo.component.html',
  styleUrls: ['./form-checkliste-lkt-biologo.component.scss', '../checklisten.scss'],
})
export class FormChecklisteLktBioLogoComponent implements OnInit {
  @Input() form: FormGroup;

  constructor() {}

  ngOnInit() {}
}
